import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatMessageTime } from '../utils/format';
import { Message } from '../types';

interface MessageBubbleProps {
  message: Message;
  isMine: boolean;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message, isMine }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: isMine ? 'flex-end' : 'flex-start',
      mb: 0.25,
    }}
  >
    <Box
      sx={{
        maxWidth: '65%',
        px: 1.5,
        py: 1,
        borderRadius: 2.5,
        borderTopRightRadius: isMine ? 4 : 20,
        borderTopLeftRadius: isMine ? 20 : 4,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
        ...(isMine
          ? {
              background: 'linear-gradient(135deg, #7c4dff, #6c3ce0)',
              color: '#fff',
              boxShadow: '0 2px 12px rgba(124,77,255,0.25)',
            }
          : {
              bgcolor: 'rgba(255,255,255,0.05)',
              color: '#e8e8f0',
              border: '1px solid rgba(255,255,255,0.06)',
            }),
      }}
    >
      {message.text && (
        <Typography
          variant="body2"
          sx={{ wordBreak: 'break-word', lineHeight: 1.4 }}
        >
          {message.text}
        </Typography>
      )}
      <Typography
        variant="caption"
        sx={{
          display: 'block',
          textAlign: 'right',
          mt: 0.25,
          opacity: 0.5,
          fontSize: '0.65rem',
          lineHeight: 1,
        }}
      >
        {formatMessageTime(message.createdAt)}
      </Typography>
    </Box>
  </Box>
);

export default MessageBubble;
